import React from 'react'
import { useTranslation } from 'react-i18next'
import { Anteroom } from 'ui'

export const SerieInfo = ({
  title,
  body,
  tag,
  audioLang,
  seasons,
  episodes
}) => {

  const { t } = useTranslation()

  const sortByReleaseDate = (first, last) => {
    return first.releaseDate.localeCompare(last.releaseDate)
  }

  const getSubtitles = () => {
    const allSubs = []
    episodes.forEach(ep => (
      ep.subtitle.forEach( sub => allSubs.push(sub.lang))
    ))
    const setSubs = new Set(allSubs)
    const sortFn = (first, last) => first.localeCompare(last)
    return Array.from(setSubs).sort(sortFn).join(', ')
  }

  const firstSeason = seasons.find(s => s.number === 1) || seasons[0] // this fix is for AyV that have easch season separated as a serie
  const firstPublished = [...firstSeason.content].sort(sortByReleaseDate)[0]
  const releaseDate = firstPublished.releaseDate
  const publishedDate = new Date(releaseDate).getFullYear()

  const seasonsText = seasons.length === 1
    ? `1 ${t('season')}`
    : `${seasons.length} ${t('seasons')}`

  const subtitlesText = getSubtitles()

  return (
    <>
      <Anteroom.HeadlineBig>{title}</Anteroom.HeadlineBig>

      <Anteroom.Divider.Root>
        <Anteroom.Divider.Child>{publishedDate}</Anteroom.Divider.Child>
        <Anteroom.Divider.Child>{seasonsText}</Anteroom.Divider.Child>
        <Anteroom.Divider.Child>{tag}</Anteroom.Divider.Child>
      </Anteroom.Divider.Root>

      <Anteroom.Body>{body}</Anteroom.Body>

      <Anteroom.Divider.Root>
        <Anteroom.Divider.Child>{t('audio')} ({audioLang})</Anteroom.Divider.Child>
        { subtitlesText && (
          <Anteroom.Divider.Child>{t('subtitles')} ({subtitlesText})</Anteroom.Divider.Child>
        )}
      </Anteroom.Divider.Root>
    </>
  )
}
